export default __webpack_public_path__ + "static/media/closeFace3.46b0a7c1.png";